import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField,
  Stack
} from '@mui/material';
import { useState } from 'react';
import { addDays } from 'date-fns';
import { req } from '../utils';
import { toast } from 'react-toastify';

export const ReminderDialog = ({ open, onClose, businessName, venueId, type = 'lead' }) => {
  const [reminderDate, setReminderDate] = useState(
    new Date(addDays(new Date(), 7)).toISOString().slice(0, 16)
  );
  const [note, setNote] = useState(`Remind me to follow up with ${businessName}`);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      
      // Convert datetime-local string to Unix timestamp (integer)
      const timestamp = parseInt(new Date(reminderDate).getTime() / 1000);
      
      console.log('Sending reminder with timestamp:', timestamp); // For debugging
      
      const response = await req('post', 'set_reminder', {
        time: timestamp,
        note: note,
        fk_id: venueId,
        fk_topic: type
      });

      if (response) {
        toast.success('Reminder set successfully');
        onClose();
      } else {
        throw new Error('Failed to set reminder');
      }
    } catch (error) {
      console.error('Error setting reminder:', error);
      toast.error('Failed to set reminder');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Set Reminder</DialogTitle>
      <DialogContent>
        <Stack spacing={3} sx={{ mt: 2 }}>
          <TextField
            fullWidth
            type="datetime-local"
            label="Reminder Date & Time"
            value={reminderDate}
            onChange={(e) => setReminderDate(e.target.value)}
            InputLabelProps={{
              shrink: true,
            }}
          />
          <TextField
            fullWidth
            multiline
            rows={3}
            label="Reminder Note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isSubmitting}>Cancel</Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          color="persiangreen"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Setting Reminder...' : 'Set Reminder'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
